import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Box, RadioCard, Text, Wrap } from '@chakra-ui/react';

const QUERY_KEY = key => `pub_${key}`;

const parseValuesFromUrl = (search, key) => {
  const params = new URLSearchParams(search);
  const value = params.get(QUERY_KEY(key));

  return value ? value : 'any';
};

const SearchFiltersEnum = props => {
  const { id: key, enumOptions, updateQueryParams } = props;

  const location = useLocation();

  // ---- LOCAL STATE (fast UI)
  const [selectedValue, setSelectedValue] = useState(() =>
    parseValuesFromUrl(location.search, key)
  );

  // ---- URL → STATE sync (back / forward / external updates)
  useEffect(() => {
    const fromUrl = parseValuesFromUrl(location.search, key);
    setSelectedValue(fromUrl);
  }, [location.search]);

  // ---- STATE → URL
  const handleChange = ({ value }) => {
    setSelectedValue(value);

    updateQueryParams({
      [QUERY_KEY(key)]: value === 'any' ? null : value,
    });
  };

  return (
    <Box>
      <RadioCard.Root
        key={key}
        value={selectedValue}
        onValueChange={handleChange}
        size={'lg'}
        align={'stretch'}
        w={'100%'}
      >
        <Wrap>
          {[{ label: 'Any', option: 'any' }, ...enumOptions].map(({ option, label, id }) => (
            <RadioCard.Item
              key={option || id}
              value={option || id}
              bgColor={selectedValue === option || selectedValue === id ? 'gray.50' : ''}
              rounded={'xl'}
              cursor="pointer"
            >
              <RadioCard.ItemHiddenInput />
              <RadioCard.ItemControl>
                <RadioCard.ItemText>{label}</RadioCard.ItemText>
                <RadioCard.ItemIndicator />
              </RadioCard.ItemControl>
            </RadioCard.Item>
          ))}
        </Wrap>
      </RadioCard.Root>
    </Box>
  );
};

export default SearchFiltersEnum;
